// extracted by mini-css-extract-plugin
export default {"MinBreakPointXL":"1600px","pageContent":"G49f147"};